module.exports = __webpack_public_path__ + "static/img/word04.70f604b5.png";